import { c as _c } from "react-compiler-runtime";
import * as React from "react";
import { ListBox as AriaListBox, ListLayout, Provider, Virtualizer } from "react-aria-components";
import { itemHeight, listBox } from "./ListBox.css.js";
import { AvatarContext } from "./shared/AvatarContext.js";

// We need a `id` property on the object to be able to use it in the ComboBox.
// Otherwise, the ComboBoxItem must set the `id` property when using it. This is
// a runtime error, so it's better to just require the `id` property on the
// object, and catch this compile time.
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export function ListBox(t0) {
  const $ = _c(11);
  let props;
  let scrollRef;
  let t1;
  if ($[0] !== t0) {
    ({
      scrollRef,
      virtualized: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = scrollRef;
    $[3] = t1;
  } else {
    props = $[1];
    scrollRef = $[2];
    t1 = $[3];
  }
  const virtualized = t1 === undefined ? false : t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [[AvatarContext, {
      size: "xxs",
      isInteractive: false,
      tooltip: false
    }]];
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== props || $[6] !== scrollRef) {
    t3 = /*#__PURE__*/_jsx(Provider, {
      values: t2,
      children: /*#__PURE__*/_jsx(AriaListBox, {
        ref: scrollRef,
        ...props,
        className: listBox
      })
    });
    $[5] = props;
    $[6] = scrollRef;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3 || $[9] !== virtualized) {
    t4 = /*#__PURE__*/_jsx(OptionalVirtualizedList, {
      virtualized: virtualized,
      children: t3
    });
    $[8] = t3;
    $[9] = virtualized;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
const OptionalVirtualizedList = t0 => {
  const $ = _c(5);
  const {
    children,
    virtualized
  } = t0;
  if (!virtualized) {
    let t1;
    if ($[0] !== children) {
      t1 = /*#__PURE__*/_jsx(_Fragment, {
        children: children
      });
      $[0] = children;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      rowHeight: itemHeight
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== children) {
    t2 = /*#__PURE__*/_jsx(Virtualizer, {
      layout: ListLayout,
      layoutOptions: t1,
      children: children
    });
    $[3] = children;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
//# sourceMappingURL=ListBox.js.map